import React from "react";

import {
    FaTimes,
    FaServer,
    FaChartLine,
    FaClock,
    FaDesktop,
    FaNetworkWired,
    FaCircle,
    FaCode
} from "react-icons/fa";



class InstallationDetailsModal extends React.Component {


    render(){


        const {

            installation,

            onClose


        } = this.props;



        if(!installation){

            return null;

        }
        




        return (


            <div className="modal-overlay">



                <div className="modal-container">



                    <div className="modal-header">


                        <h2>

                            Installation Details

                        </h2>



                        <button

                            className="modal-close"

                            onClick={onClose}

                        >

                            <FaTimes className="detail-icon" />

                        </button>



                    </div>







                    <div className="details-list">



                        <div className="installation-detail-item">

                            <FaServer  className="detail-icon"/>

                            <span className="detail-label">

                                Installation ID

                            </span>


                            <strong>

                                {installation.installationId}

                            </strong>


                        </div>






                        <div className="installation-detail-item">


                            <FaChartLine  className="detail-icon"/>


                            <span className="detail-label">

                                Symbol

                            </span>


                            <strong>

                                {installation.symbol}

                            </strong>


                        </div>






                        <div className="installation-detail-item">


                            <FaClock  className="detail-icon"/>


                            <span className="detail-label">

                                Timeframe

                            </span>


                            <strong>

                                {installation.timeframe}

                            </strong>


                        </div>






                        <div className="installation-detail-item">


                            <FaDesktop  className="detail-icon"/>


                            <span  className="detail-label">

                                MT5 Account

                            </span>


                            <strong>

                                {installation.mt5Account}

                            </strong>


                        </div>






                        <div className="installation-detail-item">


                            <FaNetworkWired  className="detail-icon"/>


                            <span className="detail-label">

                                Broker

                            </span>


                            <strong>

                                {installation.broker}

                            </strong>


                        </div>







                        <div className="installation-detail-item">

                                <div className="detail-icon">
                                    <FaCode />
                                </div>

                                <div className="detail-label">
                                    EA Version:
                                </div>

                                <div className="detail-value">
                                    {installation.eaVersion}
                                </div>

                            </div>






                        <div className="installation-detail-item">

                        <div className="detail-icon status-icon">

                            <FaCircle
                                    className={
                                        installation.status === "ACTIVE"
                                        ? "status-active"
                                        : "status-inactive"
                                    }
                            />

                        </div>


                        <div className="detail-label">
                            Status:
                        </div>


                        <div className="detail-value">

                            {installation.status}

                        </div>

                    </div>





                    </div>






                    <button


                        className="idms-btn idms-btn-primary modal-button"


                        onClick={onClose}


                    >

                        Close


                    </button>






                </div>


            </div>


        );


    }



}



export default InstallationDetailsModal;